import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

// 全局登录设置，为true的时候，所有页面必须登录 , needLogin字段不起作用
// 为false 的时候，needLogin字段为true的页面才需要登录
const loginFirst = false

const routes = [{
		path: '/',
		redirect: '/index/home2026'
	},
	{
		path: '/index',
		component: () => import('@/views/index'),
		meta: {
			title: '线上实操'
		},
		children: [{
			path: 'home2026',
			component: () => import('@/views/home/home2026'),
			meta: {
				title: '线上实操'
			}
		}, ]
	},
	{
		path: '/microscope/index',
		component: () => import('@/views/microscope/index'),
		meta: {
			title: '线上实操'
		}
	},
	{
		path: '/microscope/start',
		component: () => import('@/views/microscope/start'),
		meta: {
			title: '显微镜调试'
		}
	},
	{
		path: '/microscope/startcopy',
		component: () => import('@/views/microscope/startcopy'),
		meta: {
			title: '显微镜调试1'
		}
	},
	{
		path: '/microscope/grade',
		component: () => import('@/views/microscope/grade'),
		meta: {
			title: '评分规则'
		}
	},
	{
		path: '/microscope/slide',
		component: () => import('@/views/microscope/slide'),
		meta: {
			title: '显微镜操作判读考核'
		}
	},
	{
		path: '/microscope/luminance',
		component: () => import('@/views/microscope/luminance'),
		meta: {
			title: '亮度设置'
		}
	},
	{
		path: '/microscope/lowPowe',
		component: () => import('@/views/microscope/lowPowe'),
		meta: {
			title: '低倍镜操作考核'
		}
	},
	{
		path: '/microscope/highPoweOne',
		component: () => import('@/views/microscope/highPoweOne'),
		meta: {
			title: '高倍镜下结果判读'
		}
	},
	{
		path: '/microscope/highPoweTwo',
		component: () => import('@/views/microscope/highPoweTwo'),
		meta: {
			title: '高倍镜下结果判读'
		}
	},
	{
		path: '/microscope/highPoweThree',
		component: () => import('@/views/microscope/highPoweThree'),
		meta: {
			title: '高倍镜下结果判读'
		}
	},
	{
		path: '/microscope/highPoweFour',
		component: () => import('@/views/microscope/highPoweFour'),
		meta: {
			title: '高倍镜下结果判读'
		}
	},
	{
		path: '/microscope/results',
		component: () => import('@/views/microscope/results'),
		meta: {
			title: '考核结果'
		}
	},
	{
		path: '/microscope/answer',
		component: () => import('@/views/microscope/answer'),
		meta: {
			title: '答案展示'
		}
	},
	{
		path: '/microscope/transfer',
		component: () => import('@/views/microscope/transfer'),
		meta: {
			title: '显微镜操作判读考核'
		}
	},

	{
		path: '/microscope/Online',
		component: () => import('@/views/microscope/Online'),
		meta: {
			title: '线上实操'
		}
	},
	{
		path: '/microscope/answerAll',
		component: () => import('@/views/microscope/answerAll'),
		meta: {
			title: '答案详情'
		}
	},
	{
		path: '/microscope/other',
		component: () => import('@/views/microscope/other'),
		meta: {
			title: '其他考题'
		}
	},
	{
		path: '/microscope/pdf',
		component: () => import('@/views/microscope/pdf'),
		meta: {
			title: '答案'
		}
	},
	{
		path: '/treat/index',
		component: () => import('@/views/treat/index'),
		meta: {
			title: '诊疗思路考核'
		}
	},
	{
		path: '/treat/grade',
		component: () => import('@/views/treat/grade'),
		meta: {
			title: '评分规则'
		}
	},
	{
		path: '/treat/start',
		component: () => import('@/views/treat/start'),
		meta: {
			title: '宠物主诉'
		}
	},
	{
		path: '/treat/Catalog',
		component: () => import('@/views/treat/Catalog'),
		meta: {
			title: '考核步骤目录'
		}
	},
	{
		path: '/treat/complaint',
		component: () => import('@/views/treat/complaint'),
		meta: {
			title: '宠物主诉'
		}
	},
	{
		path: '/treat/pruritus',
		component: () => import('@/views/treat/pruritus'),
		meta: {
			title: '宠物瘙痒'
		}
	},
	{
		path: '/treat/medicalrecord',
		component: () => import('@/views/treat/medicalrecord'),
		meta: {
			title: '宠物病历'
		}
	},
	{
		path: '/treat/distinguish',
		component: () => import('@/views/treat/distinguish'),
		meta: {
			title: '鉴别诊断'
		}
	},
	{
		path: '/treat/mouth',
		component: () => import('@/views/treat/mouth'),
		meta: {
			title: '视诊-嘴部'
		}
	},
	{
		path: '/treat/mouthTwo',
		component: () => import('@/views/treat/mouthTwo'),
		meta: {
			title: '视诊-嘴部'
		}
	},
	{
		path: '/treat/point',
		component: () => import('@/views/treat/point'),
		meta: {
			title: '视诊'
		}
	},
	{
		path: '/treat/dog',
		component: () => import('@/views/treat/dog'),
		meta: {
			title: '视诊-狗'
		}
	},
	{
		path: '/treat/clinical',
		component: () => import('@/views/treat/clinical'),
		meta: {
			title: '临床检查'
		}
	},
	{
		path: '/treat/examineResult',
		component: () => import('@/views/treat/examineResult'),
		meta: {
			title: '考核结果'
		}
	},
	{
		path: '/treat/clinicaljc',
		component: () => import('@/views/treat/clinicaljc'),
		meta: {
			title: '临床检查-答题'
		}
	},
	{
		path: '/treat/clinicaltwo',
		component: () => import('@/views/treat/clinicaltwo'),
		meta: {
			title: '临床检查'
		}
	},
	{
		path: '/treat/assemble',
		component: () => import('@/views/treat/assemble'),
		meta: {
			title: '线上实操总成绩'
		}
	},
	{
		path: '/treat/Online',
		component: () => import('@/views/treat/Online'),
		meta: {
			title: '线上实操'
		}
	},
	{
		path: '/treat/answer',
		component: () => import('@/views/treat/answer'),
		meta: {
			title: '答案详情'
		}
	},
	{
		path: '/treat/other',
		component: () => import('@/views/treat/other'),
		meta: {
			title: '其他考题'
		}
	},
	{
		path: '/treat/pdf',
		component: () => import('@/views/treat/pdf'),
		meta: {
			title: '答案'
		}
	},
	{
		path: '/treat/final',
		component: () => import('@/views/treat/final'),
		meta: {
			title: '最终诊断'
		}
	},
	{
		path: '/treat/affirm',
		component: () => import('@/views/treat/affirm'),
		meta: {
			title: '确认疗法'
		}
	},
	{
		path: '/treat/affirmTwo',
		component: () => import('@/views/treat/affirmTwo'),
		meta: {
			title: '确认疗法'
		}
	},
	{
		path: '*',
		redirect: '/404'
	}
]

// add route path
// routes.forEach(route => {
//   route.path = route.path || '/' + (route.name || '')
// })
// console.log(routes)

const router = new Router({
	routes
})

router.beforeEach((to, from, next) => {
	sessionStorage.setItem('hash', to.path)
	const title = to.meta && to.meta.title
	if (title) {
		document.title = title
	}
	next()
	// // console.log('store.getters.userInfo', store.getters.userInfo)
	// if (!store.getters.userInfo) {
	//   // 可能是刷新页面，因此需要读取缓存
	//   store.dispatch('user/getCacheInfo').then(() => {
	//     // console.log('store.getters.userInfo', store.getters.userInfo)
	//     if (!store.getters.userInfo) {
	//       // 这里可以认定是没登录，不是默认页或者登录页，并且需要登录则进行登录
	//       if (to.path !== '/' && to.path !== '/login' && (loginFirst || to.meta.needLogin)) {
	//         store.dispatch('user/getInfo').then(() => {
	//           // console.log('store.getters.userInfo', store.getters.userInfo)
	//           if (!store.getters.userInfo) {
	//             next('/login')
	//             return
	//           }
	//           const title = to.meta && to.meta.title
	//           if (title) {
	//             document.title = title
	//           }
	//           next()
	//         }).catch(() => {
	//           next('/login')
	//         })
	//       }
	//     } else {
	//       const title = to.meta && to.meta.title
	//       if (title) {
	//         document.title = title
	//       }
	//       next()
	//     }
	//   })
	// } else {
	//   const title = to.meta && to.meta.title
	//   if (title) {
	//     document.title = title
	//   }
	//   next()
	// }
})
router.afterEach(route => {
	window.scroll(0, 0)
})

export {
	router
}